import React from 'react';
import '../assets/styles/login.css';

export const HeadquarterInput = ({ headquarter, imgUrl, onChange }) => (
  <label htmlFor={`${headquarter}-input`}>
    {headquarter === 'CEDESCA' ? (
      <input
        type="radio"
        name="login"
        id={`${headquarter}-input`}
        value={headquarter}
        onChange={onChange}
        defaultChecked
      />
    ) : (
      <input
        type="radio"
        name="login"
        id={`${headquarter}-input`}
        value={headquarter}
        onChange={onChange}
      />
    )}
    <img alt="Logo escuela" src={imgUrl} width="120" />
  </label>
);
